module.exports = __webpack_public_path__ + "img/cube-light.3c97776e.png";